import Link from 'next/link';
import React, { CSSProperties, HTMLAttributeAnchorTarget, ReactNode } from 'react';
import styled from 'styled-components';

import { isWebView } from '@/utils/mobile/RNPlugins';

interface Props {
  href: string;
  children: ReactNode;
  onClickNavigateToScreen?: () => void;
  target?: HTMLAttributeAnchorTarget;
  style?: CSSProperties;
  wrapperStyle?: CSSProperties;
  className?: string;
}
const LinkTag = ({
  href,
  target = '_self',
  children,
  style,
  onClickNavigateToScreen,
  wrapperStyle,
  className,
}: Props) => {
  return isWebView() ? (
    <Wrapper className={className} role='button' onClick={onClickNavigateToScreen} style={wrapperStyle}>
      {children}
    </Wrapper>
  ) : (
    <Link href={href} style={style}>
      <a target={target} style={style}>
        {children}
      </a>
    </Link>
  );
};

export default LinkTag;

const Wrapper = styled.div``;
